import { render, staticRenderFns } from "./password_change.vue?vue&type=template&id=32730a19&scoped=true&"
import script from "./password_change.vue?vue&type=script&lang=js&"
export * from "./password_change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32730a19",
  null
  
)

export default component.exports